export { default as formatDate } from './dates/format-date';
export { default as parseDate } from './dates/parse-date';
export { default as splitDateFormat } from './dates/split-date-format';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/dates.js
// module id = 819
// module chunks = 30